// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Wrap = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Wrap-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <g stroke="currentColor" clipPath={`url(#${instanceId}-Wrap_a)`}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.81 9c0 2.847 1.066 5.155 2.38 5.155S12.57 11.847 12.57 9s-1.066-5.155-2.38-5.155S7.81 6.153 7.81 9M7.81 9H5.43"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.19 3.845H7.81C6.62 3.845 5.431 5.827 5.431 9s1.19 5.155 2.38 5.155h2.379M8.3 12.173H5.922M8.3 5.827H5.922"
        />
        <path strokeDasharray="3 3" d="M1.125 9a7.875 7.875 0 1 0 15.75 0 7.875 7.875 0 0 0-15.75 0Z" />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Wrap_a`}>
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Wrap);
export default ForwardRef;
